export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LanguageSelector.vue?vue&type=template&id=2497f7c4"


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/navbar/LanguageSelector.vue?vue&type=template&id=2497f7c4
// module id = EFWc
// module chunks = 41